// extracted by mini-css-extract-plugin
export default {"RightSideHeader":"ReceivedCoulmn_RightSideHeader__xe+bo","RightSideHeaderTimer":"ReceivedCoulmn_RightSideHeaderTimer__5kEXJ"};